import api from "./Api";

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

const PICKLIST_URL = process.env.REACT_APP_PICKLIST_URL || "";
if (!PICKLIST_URL) {
  throw new Error(
    "BASE_URL is undefined. Please set REACT_APP_CASE_URL in your environment variables."
  );
}

const picklistAPI = api(PICKLIST_URL);

const fetchPreferenceStakeholderAddress = async (
  stakeholderId: any
): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/preference/addresses?stakeholderId=${stakeholderId}`
    );
    const data = response.data?.result.map((item: any) => ({
      value: item.id,
      label: item.addressInfo,
      addressType: item.addressType,
    }));

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

const fetchStakeholderPreferenceContact = async (
  stakeholderId: number,
  clientType: string
): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/preference/contacts?stakeholderId=${stakeholderId}&clientType=${clientType}`
    );
    const data = response.data?.result.map((item: any) => ({
      value: item.stakeholderContactId,
      label: item.contactFullNameDetails,
    }));

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

const fetchStakeholderPreferenceDetails = async (
  stakeholderId: any
): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/preference/details?stakeholderId=${stakeholderId}`
    );
    // Map the result to transform pickListItemId into value and displayName into label

    return response.data?.result;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

const addStakeholderPreference = async (
  preferenceData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await picklistAPI.post<ApiResponse<any>>(
      "/api/stakeholder/preference/add",
      preferenceData
    );
    const { isSuccess, statusCode, message, result } = response.data;
    return { isSuccess, statusCode, message, result };
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

const updateStakeholderPreference = async (
  preferenceData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await picklistAPI.post<ApiResponse<any>>(
      "/api/stakeholder/preference/update",
      preferenceData
    );
    const { isSuccess, statusCode, message, result } = response.data;
    return { isSuccess, statusCode, message, result };
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

export {
  fetchPreferenceStakeholderAddress,
  fetchStakeholderPreferenceContact,
  fetchStakeholderPreferenceDetails,
  addStakeholderPreference,
  updateStakeholderPreference,
};
